import { useEffect } from 'react';

import { config } from '@/app/config';

/**
 * Sets the browser title. Matters for orientation when several tabs are open,
 * and screen readers announce it on navigation.
 */
export function useDocumentTitle(title?: string): void {
  useEffect(() => {
    document.title = title ? `${title} · ${config.appName}` : config.appName;
  }, [title]);
}
